<button type="button" class="btn btn-sm btn-info" (click)="showPopup()">
  <span class="glyphicon glyphicon-envelope"></span> E-Mail
</button>

<dx-popup
  class="popup"
  title="E-Mail"
  [height]="'auto'"
  [width]="'70%'"
  [showTitle]="true"
  [(visible)]="popupVisible"
  style="display: inline-block"
>
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view
      #scrollView
      id="scrollview"
      [scrollByContent]="true"
      [scrollByThumb]="true"
      [showScrollbar]="'onHover'"
      reachBottomText="Updating..."
    >
      <div style="padding-right: 15px">
        <div class="panel panel-primary">
          <div class="panel-heading">Email Daten</div>
          <div class="panel-body">
            <dx-form [formData]="emailData" #emailForm>
              <dxi-item
                editorType="dxRadioGroup"
                dataField="useFrom"
                [editorOptions]="{
                  dataSource: fromOptions,
                  displayExpr: 'text',
                  valueExpr: 'value',
                  layout: 'horizontal',
                  onValueChanged: onSenderChanged
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
                <dxi-validation-rule
                  type="required"
                  message="Wird benötigt!"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item dataField="mailTo" [label]="{ text: 'An' }">
                <dxi-validation-rule
                  type="required"
                  message="Bitte einen Empfänger angeben"
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="email"
                  message="Bitte eine valide Email angeben"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item dataField="subject" [label]="{ text: 'Betreff' }">
                <dxi-validation-rule
                  type="required"
                  message="Bitte einen Betreff angeben"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item
                dataField="content"
                editorType="dxTextArea"
                [editorOptions]="{ height: '160px' }"
                [label]="{ text: 'Inhalt' }"
              ></dxi-item>
              <dxi-item
                dataField="signature"
                editorType="dxTextArea"
                [editorOptions]="{ height: '80px' }"
                [label]="{ text: 'Signatur' }"
              ></dxi-item>
            </dx-form>
          </div>
        </div>

        <div class="panel panel-primary" [hidden]="!isWiedervorlageVisible">
          <div class="panel-heading">
            <dx-check-box
              text="Wiedervorlage erstellen"
              [(value)]="isWiedervorlageEnabled"
            ></dx-check-box>
          </div>
          <div class="panel-body">
            <dx-form
              [formData]="wiedervorlageData"
              [colCount]="4"
              [disabled]="!isWiedervorlageEnabled"
              #wiedervorlageForm
            >
              <dxi-item
                dataField="userId"
                [label]="{ text: 'Mitarbeiter' }"
                editorType="dxSelectBox"
                [editorOptions]="{
                  items: available_Benutzer,
                  displayExpr: 'name',
                  valueExpr: 'id'
                }"
              >
                <dxi-validation-rule
                  type="required"
                  message="Bitte einen Mitarbeiter auswählen"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item
                dataField="grundId"
                [label]="{ text: 'Grund' }"
                editorType="dxSelectBox"
                [editorOptions]="{
                  items: available_Gruende,
                  displayExpr: 'name',
                  valueExpr: 'id'
                }"
              >
                <dxi-validation-rule
                  type="required"
                  message="Bitte einen Grund auswählen"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item
                dataField="termin"
                [label]="{ text: 'Termin' }"
                editorType="dxDateBox"
              >
                <dxi-validation-rule
                  type="required"
                  message="Bitte einen Termin angeben"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item dataField="betreff">
                <dxi-validation-rule
                  type="required"
                  message="Bitte einen Betreff angeben"
                ></dxi-validation-rule>
              </dxi-item>
            </dx-form>
          </div>
        </div>
      </div>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      text: 'Senden',
      onClick: onClickSend
    }"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      text: 'Abbrechen',
      onClick: onClickClose
    }"
  >
  </dxi-popup-toolbar-item>
</dx-popup>
